/** CoStar.Api.ListingMarketplace.SiteMap.ViewModels.SiteMapSeoType */
export var SiteMapSeoType;
(function (SiteMapSeoType) {
    SiteMapSeoType[SiteMapSeoType["None"] = 0] = "None";
    SiteMapSeoType[SiteMapSeoType["ForLease"] = 1] = "ForLease";
    SiteMapSeoType[SiteMapSeoType["ForSale"] = 2] = "ForSale";
})(SiteMapSeoType || (SiteMapSeoType = {}));
/** CoStar.Api.ListingMarketplace.SiteMap.ViewModels.ResourceType */
export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["None"] = 0] = "None";
    ResourceType[ResourceType["State"] = 1] = "State";
    ResourceType[ResourceType["City"] = 2] = "City";
    ResourceType[ResourceType["County"] = 3] = "County";
    ResourceType[ResourceType["Neighborhood"] = 4] = "Neighborhood";
    ResourceType[ResourceType["Region"] = 5] = "Region";
})(ResourceType || (ResourceType = {}));
